import { useContext } from "react"
import { SliceContext } from "../components/SliceProvider";
export default function useSlice() {
    const context = useContext(SliceContext)

    if (!context) {
        throw new Error("Debes utilizar el hook useVideo dentro del SliceProvider")
    }

    return context;

}